import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';

export const getPurchaseCategoryFromRoute = (url: string): { category: string; eventFrom: EventFrom } => {
    if (/.*\/checkout\/summary*/i.test(url)) {
        return {
            category: 'resumen_compra',
            eventFrom: EventFrom.checkout,
        };
    }
    if (/.*\/checkout.*/i.test(url)) {
        return {
            category: 'pago',
            eventFrom: EventFrom.checkout,
        };
    }
    if (/.*\/order-repayment.*/i.test(url)) {
        return {
            category: 'repago',
            eventFrom: EventFrom.repay,
        };
    }
    return {
        category: 'pago',
        eventFrom: EventFrom.checkout,
    };
};
